module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_06.a60d788a.svg";